import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { UspModule } from "@app/api/core/usp/usp";
import { breakPointTablet } from "@app/util/detect-view";
import { useInterval } from "@app/util/interval";
import { settingsState as rdxSettingsState } from "@app/redux/reducers/settings";
import IcnCheck from "@assets/icons/check-fat.svg";
import { HtmlRenderComponent } from "@app/core/html-render";

import { ImageComponent } from "../image";
import styles from "./usp-component.module.scss";
import { IconComponent } from "../icon";

export interface IUSPProps {
  uspModule: UspModule;
  defaultIcons?: boolean;
}

const FIRST_ITEM_TO_SHOW_ON_MOBILE = 0;

const timerIntervalDuration = 3000;

export const USP = ({ uspModule, defaultIcons }: IUSPProps) => {
  const settingsState = useSelector(rdxSettingsState);
  const { screenSize } = settingsState;

  const [itemToShow, setItemToShow] = useState(FIRST_ITEM_TO_SHOW_ON_MOBILE);
  const { uniqueSellingPoints } = uspModule;
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const IS_TABLET = (screenSize && screenSize.breakpointPixels <= breakPointTablet) || false;
    setIsTablet(IS_TABLET);
  }, [screenSize]);

  useInterval(
    () => {
      setNextVisibleElement();
    },
    isTablet ? timerIntervalDuration : null
  );

  const setNextVisibleElement = () => {
    const itemToShowNext = itemToShow + 1;
    if (itemToShowNext === uniqueSellingPoints.length) {
      setItemToShow(0);
    } else {
      setItemToShow(itemToShow + 1);
    }
  };

  return (
    <div className={styles["usp"]}>
      {uniqueSellingPoints.map((item, index) => {
        let itemVisibility = 1;
        if (isTablet) {
          itemVisibility = index === itemToShow ? 1 : 0;
        }

        return (
          <div
            key={index}
            className={styles["usp__item"]}
            style={{ display: "flex", opacity: itemVisibility, visibility: !itemVisibility ? "hidden" : "initial" }}
          >
            <Link to={item.link.url} className={styles["usp__link"]}>
              {defaultIcons ? (
                <div className={styles.icon}>
                  <IconComponent icon={IcnCheck} size="12px" />
                </div>
              ) : (
                <ImageComponent src={item.icon} />
              )}
              <span style={{ marginLeft: "10px" }}>
                <HtmlRenderComponent html={decodeHtmlEntities(item.link.title)} />
              </span>
            </Link>
          </div>
        );
      })}
    </div>
  );
};

// Or use a more comprehensive approach:
export const decodeHtmlEntities = (text: string): string => {
  return text
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
};
